// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type Options as Options2, type TDataShape, formDataBodySerializer } from './client';
import { client } from './client.gen';
import type {
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData,
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostErrors,
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponses,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostErrors,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponses,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostErrors,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponses,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostErrors,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponses,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostErrors,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponses,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostErrors,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponses,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostErrors,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponses,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostErrors,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponses,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostErrors,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponses,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostErrors,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponses,
  CreateExploreImageV1ExploreImagesPostData,
  CreateExploreImageV1ExploreImagesPostErrors,
  CreateExploreImageV1ExploreImagesPostResponses,
  CreateExplorePdpV1ExplorePdpsPostData,
  CreateExplorePdpV1ExplorePdpsPostErrors,
  CreateExplorePdpV1ExplorePdpsPostResponses,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostErrors,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponses,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostData,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostErrors,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponses,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostData,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostErrors,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostResponses,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostErrors,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponses,
  CreateOrganizationV1OrganizationsPostData,
  CreateOrganizationV1OrganizationsPostErrors,
  CreateOrganizationV1OrganizationsPostResponses,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostErrors,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponses,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostErrors,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponses,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostData,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostErrors,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostResponses,
  CreateQueryV1ExploreQueriesPostData,
  CreateQueryV1ExploreQueriesPostErrors,
  CreateQueryV1ExploreQueriesPostResponses,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostErrors,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponses,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteErrors,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponses,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteErrors,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponses,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteErrors,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponses,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteErrors,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponses,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteErrors,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponses,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteErrors,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponses,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteErrors,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponses,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteErrors,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponses,
  DeleteUserV1UsersUserIdDeleteData,
  DeleteUserV1UsersUserIdDeleteErrors,
  DeleteUserV1UsersUserIdDeleteResponses,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostErrors,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponses,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetErrors,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponses,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostErrors,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponses,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetErrors,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponses,
  GetAudienceV1AudiencesAudienceIdGetData,
  GetAudienceV1AudiencesAudienceIdGetErrors,
  GetAudienceV1AudiencesAudienceIdGetResponses,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetErrors,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponses,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetErrors,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponses,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetErrors,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponses,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetErrors,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponses,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetErrors,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponses,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetErrors,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponses,
  GetExploreImageV1ExploreImagesExploreImageIdGetData,
  GetExploreImageV1ExploreImagesExploreImageIdGetErrors,
  GetExploreImageV1ExploreImagesExploreImageIdGetResponses,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetData,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetErrors,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponses,
  GetFeatureFlagV1FeatureFlagsFlagGetData,
  GetFeatureFlagV1FeatureFlagsFlagGetErrors,
  GetFeatureFlagV1FeatureFlagsFlagGetResponses,
  GetIcpProductCategoriesV1IcpProductCategoriesGetData,
  GetIcpProductCategoriesV1IcpProductCategoriesGetErrors,
  GetIcpProductCategoriesV1IcpProductCategoriesGetResponses,
  GetIcpProductCategoriesV1L1ProductCategoriesGetData,
  GetIcpProductCategoriesV1L1ProductCategoriesGetErrors,
  GetIcpProductCategoriesV1L1ProductCategoriesGetResponses,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetErrors,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponses,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetErrors,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponses,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetErrors,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponses,
  GetImageByIdV1ImagesImageIdGetData,
  GetImageByIdV1ImagesImageIdGetErrors,
  GetImageByIdV1ImagesImageIdGetResponses,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetData,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetErrors,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetResponses,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetErrors,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponses,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetData,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetErrors,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetResponses,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetErrors,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponses,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetErrors,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponses,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetErrors,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponses,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetErrors,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponses,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetErrors,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponses,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetErrors,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponses,
  GetOrganizationV1OrganizationsOrgIdGetData,
  GetOrganizationV1OrganizationsOrgIdGetErrors,
  GetOrganizationV1OrganizationsOrgIdGetResponses,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetData,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetErrors,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponses,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetErrors,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponses,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetErrors,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponses,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetErrors,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponses,
  GetProductCategoriesV1ProductCategoriesGetData,
  GetProductCategoriesV1ProductCategoriesGetErrors,
  GetProductCategoriesV1ProductCategoriesGetResponses,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetErrors,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponses,
  GetProductCategoryV1ProductCategoriesCategoryIdGetData,
  GetProductCategoryV1ProductCategoriesCategoryIdGetErrors,
  GetProductCategoryV1ProductCategoriesCategoryIdGetResponses,
  GetQueryV1ExploreQueriesQueryIdGetData,
  GetQueryV1ExploreQueriesQueryIdGetErrors,
  GetQueryV1ExploreQueriesQueryIdGetResponses,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetErrors,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponses,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetErrors,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponses,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetErrors,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponses,
  GetScrapedPdpV1PdpsRequestIdGetData,
  GetScrapedPdpV1PdpsRequestIdGetErrors,
  GetScrapedPdpV1PdpsRequestIdGetResponses,
  GetUserV1UsersUserIdGetData,
  GetUserV1UsersUserIdGetErrors,
  GetUserV1UsersUserIdGetResponses,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetErrors,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponses,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostErrors,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostResponses,
  HealthcheckGetData,
  HealthcheckGetErrors,
  HealthcheckGetResponses,
  HealthcheckHealthcheckGetData,
  HealthcheckHealthcheckGetErrors,
  HealthcheckHealthcheckGetResponses,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetErrors,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponses,
  ListExploreImagesV1ExploreImagesGetData,
  ListExploreImagesV1ExploreImagesGetErrors,
  ListExploreImagesV1ExploreImagesGetResponses,
  ListFeatureFlagsV1FeatureFlagsGetData,
  ListFeatureFlagsV1FeatureFlagsGetErrors,
  ListFeatureFlagsV1FeatureFlagsGetResponses,
  ListImageClassificationsV1ExploreClassificationsGetData,
  ListImageClassificationsV1ExploreClassificationsGetErrors,
  ListImageClassificationsV1ExploreClassificationsGetResponses,
  ListRetailerRegionsV1RetailerRegionsGetData,
  ListRetailerRegionsV1RetailerRegionsGetErrors,
  ListRetailerRegionsV1RetailerRegionsGetResponses,
  LoginUserV1UsersAuthenticatePostData,
  LoginUserV1UsersAuthenticatePostErrors,
  LoginUserV1UsersAuthenticatePostResponses,
  LogoutUserV1UsersUserIdLogoutPostData,
  LogoutUserV1UsersUserIdLogoutPostErrors,
  LogoutUserV1UsersUserIdLogoutPostResponses,
  ReadyReadyGetData,
  ReadyReadyGetErrors,
  ReadyReadyGetResponses,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostErrors,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostResponses,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteErrors,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponses,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteErrors,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponses,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchErrors,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponses,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutData,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutErrors,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponses,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostErrors,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponses,
  ResetPasswordV1UsersPasswordPutData,
  ResetPasswordV1UsersPasswordPutErrors,
  ResetPasswordV1UsersPasswordPutResponses,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetErrors,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponses,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetErrors,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponses,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetErrors,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponses,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetErrors,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponses,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetErrors,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponses,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetData,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetErrors,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponses,
  SetPasswordV1UsersUserIdPasswordPostData,
  SetPasswordV1UsersUserIdPasswordPostErrors,
  SetPasswordV1UsersUserIdPasswordPostResponses,
  SsoAuthorizeV1AuthSsoAuthorizeGetData,
  SsoAuthorizeV1AuthSsoAuthorizeGetErrors,
  SsoAuthorizeV1AuthSsoAuthorizeGetResponses,
  SsoCallbackV1AuthSsoCallbackGetData,
  SsoCallbackV1AuthSsoCallbackGetErrors,
  SsoCallbackV1AuthSsoCallbackGetResponses,
  SsoCheckV1AuthSsoCheckGetData,
  SsoCheckV1AuthSsoCheckGetErrors,
  SsoCheckV1AuthSsoCheckGetResponses,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchErrors,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponses,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchErrors,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchResponses,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutErrors,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponses,
  UpdateOrganizationV1OrganizationsOrgIdPutData,
  UpdateOrganizationV1OrganizationsOrgIdPutErrors,
  UpdateOrganizationV1OrganizationsOrgIdPutResponses,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchErrors,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponses,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutErrors,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponses,
  UpdateQueryV1ExploreQueriesQueryIdPatchData,
  UpdateQueryV1ExploreQueriesQueryIdPatchErrors,
  UpdateQueryV1ExploreQueriesQueryIdPatchResponses,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutErrors,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponses,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostErrors,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponses,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostErrors,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Sso Check
 */
export const ssoCheckV1AuthSsoCheckGet = <ThrowOnError extends boolean = false>(
  options: Options<SsoCheckV1AuthSsoCheckGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<SsoCheckV1AuthSsoCheckGetResponses, SsoCheckV1AuthSsoCheckGetErrors, ThrowOnError>({
    url: '/v1/auth/sso-check',
    ...options,
  });

/**
 * Sso Authorize
 */
export const ssoAuthorizeV1AuthSsoAuthorizeGet = <ThrowOnError extends boolean = false>(
  options: Options<SsoAuthorizeV1AuthSsoAuthorizeGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SsoAuthorizeV1AuthSsoAuthorizeGetResponses,
    SsoAuthorizeV1AuthSsoAuthorizeGetErrors,
    ThrowOnError
  >({ url: '/v1/auth/sso-authorize', ...options });

/**
 * Sso Callback
 */
export const ssoCallbackV1AuthSsoCallbackGet = <ThrowOnError extends boolean = false>(
  options?: Options<SsoCallbackV1AuthSsoCallbackGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    SsoCallbackV1AuthSsoCallbackGetResponses,
    SsoCallbackV1AuthSsoCallbackGetErrors,
    ThrowOnError
  >({ url: '/v1/auth/sso-callback', ...options });

/**
 * Get Audience
 */
export const getAudienceV1AudiencesAudienceIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetAudienceV1AudiencesAudienceIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAudienceV1AudiencesAudienceIdGetResponses,
    GetAudienceV1AudiencesAudienceIdGetErrors,
    ThrowOnError
  >({ url: '/v1/audiences/{audience_id}', ...options });

/**
 * Get Artifact
 *
 * Returns a signed URL to an image's artifact
 */
export const getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponses,
    GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}/artifacts/{artifact_type}', ...options });

/**
 * Get Bulk Refresh Job
 */
export const getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponses,
    GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/bulk_refresh/{bulk_refresh_id}', ...options });

/**
 * Bulk Refresh Pdps
 */
export const bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponses,
    BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/bulk_refresh',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Import Csv
 *
 * Bulk imports PDPs from a CSV file containing item IDs, retailer, and region.
 *
 * Accepts a CSV file with 3 columns:
 * - Column 1: Item ID (format depends on retailer; for Amazon, this is an ASIN)
 * - Column 2: Retailer (e.g., "amazon")
 * - Column 3: Region (e.g., "us")
 *
 * Returns:
 * BulkImportResponse with bulk import ID, message, and counts
 *
 * Raises:
 * 400: Invalid file format, size, row count, missing retailer/region, or unsupported retailer
 * 429: Rate limit exceeded (1 import per minute per user)
 * 500: Internal server errors
 */
export const bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponses,
    BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/v1/portfolios/{portfolio_id}/bulk-import/csv',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Bulk Import
 *
 * Get status and details of a bulk import job.
 *
 * Returns:
 * BulkImportView with import status, counts, and completion information
 */
export const getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponses,
    GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/bulk-import/{bulk_import_id}', ...options });

/**
 * Search Collections
 */
export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponses,
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/collections', ...options });

/**
 * Create Collection
 */
export const createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponses,
    CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/assets/images/collections',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Collection
 *
 * Delete a collection and all its images.
 */
export const deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponses,
    DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}', ...options });

/**
 * Get Collection
 */
export const getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponses,
    GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}', ...options });

/**
 * Rename Collection
 *
 * Rename a collection.
 */
export const renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponses,
    RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Image From Collection
 *
 * Delete a single image from a collection.
 */
export const deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponses,
    DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}/images/{image_id}', ...options });

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 */
export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponses,
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}/images', ...options });

/**
 * Upload Image To Collection
 */
export const uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponses,
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/assets/images/collections/{collection_id}/images',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Benchmark Images
 *
 * Retrieves the benchmark images for a product category
 */
export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponses,
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/product-categories/{product_category_id}/benchmark-images', ...options });

/**
 * List Explore Images
 *
 * List ExploreImage records with optional filters for idempotency checks.
 */
export const listExploreImagesV1ExploreImagesGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListExploreImagesV1ExploreImagesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListExploreImagesV1ExploreImagesGetResponses,
    ListExploreImagesV1ExploreImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/images', ...options });

/**
 * Create Explore Image
 *
 * Create a new ExploreImage record for explore functionality.
 */
export const createExploreImageV1ExploreImagesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateExploreImageV1ExploreImagesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateExploreImageV1ExploreImagesPostResponses,
    CreateExploreImageV1ExploreImagesPostErrors,
    ThrowOnError
  >({
    url: '/v1/explore/images',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Explore Image
 *
 * Delete an ExploreImage record.
 */
export const deleteExploreImageV1ExploreImagesExploreImageIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponses,
    DeleteExploreImageV1ExploreImagesExploreImageIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/explore/images/{explore_image_id}', ...options });

/**
 * Get Explore Image
 *
 * Get a specific ExploreImage record by ID.
 */
export const getExploreImageV1ExploreImagesExploreImageIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetExploreImageV1ExploreImagesExploreImageIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetExploreImageV1ExploreImagesExploreImageIdGetResponses,
    GetExploreImageV1ExploreImagesExploreImageIdGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/images/{explore_image_id}', ...options });

/**
 * Replace Explore Image
 *
 * Replace an ExploreImage record completely (all fields required).
 */
export const replaceExploreImageV1ExploreImagesExploreImageIdPut = <ThrowOnError extends boolean = false>(
  options: Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponses,
    ReplaceExploreImageV1ExploreImagesExploreImageIdPutErrors,
    ThrowOnError
  >({
    url: '/v1/explore/images/{explore_image_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Explore Pdp
 *
 * Create a new ExplorePDP record for explore functionality.
 */
export const createExplorePdpV1ExplorePdpsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateExplorePdpV1ExplorePdpsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateExplorePdpV1ExplorePdpsPostResponses,
    CreateExplorePdpV1ExplorePdpsPostErrors,
    ThrowOnError
  >({
    url: '/v1/explore/pdps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Explore Pdp
 *
 * Get a specific ExplorePDP record by ID.
 */
export const getExplorePdpV1ExplorePdpsExplorePdpIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetExplorePdpV1ExplorePdpsExplorePdpIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponses,
    GetExplorePdpV1ExplorePdpsExplorePdpIdGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/pdps/{explore_pdp_id}', ...options });

/**
 * Update Explore Pdp
 *
 * Update an ExplorePDP record with partial data.
 */
export const updateExplorePdpV1ExplorePdpsExplorePdpIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponses,
    UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchErrors,
    ThrowOnError
  >({
    url: '/v1/explore/pdps/{explore_pdp_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Classification Feedback
 *
 * Get the user's ClassificationFeedback record for a specific ExploreImage.
 */
export const getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet = <ThrowOnError extends boolean = false>(
  options: Options<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponses,
    GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/images/{explore_image_id}/feedback', ...options });

/**
 * Create Classification Feedback
 *
 * Create a new ClassificationFeedback record for an ExploreImage.
 */
export const createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponses,
    CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostErrors,
    ThrowOnError
  >({
    url: '/v1/explore/images/{explore_image_id}/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Image Classification
 *
 * Get a specific ImageClassification record by ID.
 */
export const getImageClassificationV1ExploreClassificationsClassificationIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageClassificationV1ExploreClassificationsClassificationIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageClassificationV1ExploreClassificationsClassificationIdGetResponses,
    GetImageClassificationV1ExploreClassificationsClassificationIdGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/classifications/{classification_id}', ...options });

/**
 * List Image Classifications
 *
 * Get a list of all ImageClassification records.
 */
export const listImageClassificationsV1ExploreClassificationsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListImageClassificationsV1ExploreClassificationsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListImageClassificationsV1ExploreClassificationsGetResponses,
    ListImageClassificationsV1ExploreClassificationsGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/classifications', ...options });

/**
 * List Classification Images
 *
 * Get a paginated list of ExploreImage records with the given classification ID.
 *
 * Filters:
 * - product_category_id: Filter by product category
 * - query_id: Filter by query
 * - min_score: Minimum vizit_score (inclusive, default: 80)
 * - max_score: Maximum vizit_score (inclusive)
 *
 * Sorting:
 * - sort: "asc" or "desc" (default: "desc") - sorts by vizit_score
 *
 * Deduplication:
 * - Results are deduplicated by (name, brand, score_clip/score_effnet)
 * - Uses ROW_NUMBER() PARTITION BY ei.name, ei.brand, ei.score_*
 * - Keeps the first row (rn = 1) per (name, brand, score) pair
 * - Note: vizit_score may differ across variant images in the same group
 * - Pagination and total count reflect deduplicated results
 */
export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponses,
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/classifications/{classification_id}/images', ...options });

/**
 * Create Query
 *
 * Create a new Query record for explore functionality.
 */
export const createQueryV1ExploreQueriesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateQueryV1ExploreQueriesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateQueryV1ExploreQueriesPostResponses,
    CreateQueryV1ExploreQueriesPostErrors,
    ThrowOnError
  >({
    url: '/v1/explore/queries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Query
 *
 * Get a specific Query record by ID.
 */
export const getQueryV1ExploreQueriesQueryIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetQueryV1ExploreQueriesQueryIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetQueryV1ExploreQueriesQueryIdGetResponses,
    GetQueryV1ExploreQueriesQueryIdGetErrors,
    ThrowOnError
  >({ url: '/v1/explore/queries/{query_id}', ...options });

/**
 * Update Query
 *
 * Update a Query record with partial data.
 */
export const updateQueryV1ExploreQueriesQueryIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQueryV1ExploreQueriesQueryIdPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateQueryV1ExploreQueriesQueryIdPatchResponses,
    UpdateQueryV1ExploreQueriesQueryIdPatchErrors,
    ThrowOnError
  >({
    url: '/v1/explore/queries/{query_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Feature Flags
 *
 * Evaluate all BE feature flags for the current authenticated user.
 */
export const listFeatureFlagsV1FeatureFlagsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListFeatureFlagsV1FeatureFlagsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListFeatureFlagsV1FeatureFlagsGetResponses,
    ListFeatureFlagsV1FeatureFlagsGetErrors,
    ThrowOnError
  >({ url: '/v1/feature-flags/', ...options });

/**
 * Get Feature Flag
 *
 * Evaluate a single feature flag for the current authenticated user.
 */
export const getFeatureFlagV1FeatureFlagsFlagGet = <ThrowOnError extends boolean = false>(
  options: Options<GetFeatureFlagV1FeatureFlagsFlagGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFeatureFlagV1FeatureFlagsFlagGetResponses,
    GetFeatureFlagV1FeatureFlagsFlagGetErrors,
    ThrowOnError
  >({ url: '/v1/feature-flags/{flag}', ...options });

/**
 * Search Ideas
 */
export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet = <ThrowOnError extends boolean = false>(
  options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponses,
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}/ideas', ...options });

/**
 * Create Idea
 */
export const createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponses,
    CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}/ideas', ...options });

/**
 * Get Idea
 */
export const getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponses,
    GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}/ideas/{idea_id}', ...options });

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 */
export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGet = <ThrowOnError extends boolean = false>(
  options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponses,
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images', ...options });

/**
 * Upload Image
 *
 * Uploads image metadata and returns the Image model
 */
export const uploadImageV1PortfoliosPortfolioIdAssetsImagesPost = <ThrowOnError extends boolean = false>(
  options: Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponses,
    UploadImageV1PortfoliosPortfolioIdAssetsImagesPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/assets/images',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Image
 *
 * Delete a portfolio image.
 */
export const deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponses,
    DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}', ...options });

/**
 * Get Image
 *
 * returns an Image by ID
 */
export const getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponses,
    GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/assets/images/{image_id}', ...options });

/**
 * Create Image Score
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createImageScoreV1AssetsImagesImageIdRawScorePost = <ThrowOnError extends boolean = false>(
  options: Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateImageScoreV1AssetsImagesImageIdRawScorePostResponses,
    CreateImageScoreV1AssetsImagesImageIdRawScorePostErrors,
    ThrowOnError
  >({
    url: '/v1/assets/images/{image_id}/raw-score',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Image Classification
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createImageClassificationV1AssetsImagesImageIdClassificationPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponses,
    CreateImageClassificationV1AssetsImagesImageIdClassificationPostErrors,
    ThrowOnError
  >({
    url: '/v1/assets/images/{image_id}/classification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Batch Update Image Classifications
 *
 * Internal endpoint called by Lambda. Updates classifications for multiple
 * images in a single request. Returns minimal dict response — Lambda callers
 * only check the status code.
 */
export const batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponses,
    BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostErrors,
    ThrowOnError
  >({
    url: '/v1/assets/images/classifications/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Exclusion Prediction
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponses,
    CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostErrors,
    ThrowOnError
  >({
    url: '/v1/assets/images/{image_id}/exclusion-prediction',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Image Count
 */
export const getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponses,
    GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/image_count', ...options });

/**
 * Generate Prompts For Image
 *
 * Create 7 ImageGenPrompts records for an image and trigger parallel processing.
 */
export const generatePromptsForImageV1ImagesImageIdGeneratePromptsPost = <ThrowOnError extends boolean = false>(
  options: Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponses,
    GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostErrors,
    ThrowOnError
  >({ url: '/v1/images/{image_id}/generate-prompts', ...options });

/**
 * Get Batch Status
 *
 * Get the status of a batch of ImageGenPrompts records for a specific image.
 */
export const getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponses,
    GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetErrors,
    ThrowOnError
  >({ url: '/v1/images/{image_id}/generate-prompts/{batch_id}', ...options });

/**
 * Delete Image Gen Prompt
 *
 * Delete an ImageGenPrompts record.
 */
export const deleteImageGenPromptV1ImageGenPromptsPromptIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponses,
    DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/image-gen-prompts/{prompt_id}', ...options });

/**
 * Get Image Gen Prompt
 *
 * Get a specific ImageGenPrompts record by ID.
 */
export const getImageGenPromptV1ImageGenPromptsPromptIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageGenPromptV1ImageGenPromptsPromptIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageGenPromptV1ImageGenPromptsPromptIdGetResponses,
    GetImageGenPromptV1ImageGenPromptsPromptIdGetErrors,
    ThrowOnError
  >({ url: '/v1/image-gen-prompts/{prompt_id}', ...options });

/**
 * Update Image Gen Prompt
 *
 * Update an ImageGenPrompts record status and/or output.
 */
export const updateImageGenPromptV1ImageGenPromptsPromptIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchResponses,
    UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchErrors,
    ThrowOnError
  >({
    url: '/v1/image-gen-prompts/{prompt_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Image By Id
 *
 * Get a specific Image record by ID (for Lambda function use).
 */
export const getImageByIdV1ImagesImageIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageByIdV1ImagesImageIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageByIdV1ImagesImageIdGetResponses,
    GetImageByIdV1ImagesImageIdGetErrors,
    ThrowOnError
  >({ url: '/v1/images/{image_id}', ...options });

/**
 * Get Image Gen Prompts For Image
 *
 * Get all ImageGenPrompts records for a specific image.
 */
export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponses,
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetErrors,
    ThrowOnError
  >({ url: '/v1/images/{image_id}/gen-prompts', ...options });

/**
 * Get Image Gen Prompts For Category
 *
 * Get all ImageGenPrompts records for a specific product category, optionally filtered by status.
 */
export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponses,
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetErrors,
    ThrowOnError
  >({ url: '/v1/product-categories/{category_id}/gen-prompts', ...options });

/**
 * Get Image Order
 */
export const getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponses,
    GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/image_order', ...options });

/**
 * Get Image Mix
 */
export const getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponses,
    GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/image_mix', ...options });

/**
 * Get Image Scores
 */
export const getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponses,
    GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/image_scores', ...options });

/**
 * Create Organization
 */
export const createOrganizationV1OrganizationsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrganizationV1OrganizationsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateOrganizationV1OrganizationsPostResponses,
    CreateOrganizationV1OrganizationsPostErrors,
    ThrowOnError
  >({
    url: '/v1/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Organization Icp Product Category
 */
export const deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponses,
    DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}/product_categories/{icp_product_category_id}', ...options });

/**
 * Create Organization Icp Product Category
 *
 * Creates an ICP product category linked to an organization, returns the ICP product category
 */
export const createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponses,
    CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}/product_categories/{icp_product_category_id}', ...options });

/**
 * Remove Retailer Region From Organization
 *
 * Unlink a retailer region from an organization.
 */
export const removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponses,
    RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}/retailer-regions/{retailer_region_id}', ...options });

/**
 * Add Retailer Region To Organization
 *
 * Link a retailer region to an organization.
 */
export const addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponses,
    AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}/retailer-regions/{retailer_region_id}', ...options });

/**
 * Get Organization
 */
export const getOrganizationV1OrganizationsOrgIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganizationV1OrganizationsOrgIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetOrganizationV1OrganizationsOrgIdGetResponses,
    GetOrganizationV1OrganizationsOrgIdGetErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}', ...options });

/**
 * Update Organization
 */
export const updateOrganizationV1OrganizationsOrgIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganizationV1OrganizationsOrgIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateOrganizationV1OrganizationsOrgIdPutResponses,
    UpdateOrganizationV1OrganizationsOrgIdPutErrors,
    ThrowOnError
  >({
    url: '/v1/organizations/{org_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Retailers For Organization
 *
 * List distinct retailer regions available to an organization.
 */
export const getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet = <ThrowOnError extends boolean = false>(
  options: Options<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponses,
    GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{org_id}/retailers', ...options });

/**
 * Get Users For Organization
 */
export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponses,
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/users', ...options });

/**
 * Search Pdps
 */
export const searchPdpsV1PortfoliosPortfolioIdPdpsGet = <ThrowOnError extends boolean = false>(
  options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponses,
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps', ...options });

/**
 * Create Pdp
 */
export const createPdpV1PortfoliosPortfolioIdPdpsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePdpV1PortfoliosPortfolioIdPdpsPostResponses,
    CreatePdpV1PortfoliosPortfolioIdPdpsPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Unlisted Pdp
 *
 * Creates a manually-entered PDP with user-provided data.
 * No external scraping. Item ID is auto-generated in VZT format.
 */
export const createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponses,
    CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/unlisted',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export Pdps Csv
 *
 * Download PDP search results as CSV with the standard column layout.
 */
export const exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet = <ThrowOnError extends boolean = false>(
  options: Options<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponses,
    ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/export', ...options });

/**
 * Delete Pdp
 *
 * Delete a PDP from a portfolio and all its associated images.
 */
export const deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponses,
    DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}', ...options });

/**
 * Get Pdp
 */
export const getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponses,
    GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}', ...options });

/**
 * Update Pdp
 */
export const updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponses,
    UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complex Search Pdps
 *
 * Complex PDP search with nested query conditions.
 *
 * Supports:
 * - Nested AND/OR logical conditions
 * - Multiple comparison operators (=, !=, >, >=, <, <=, like, ilike, in, not_in, is_null, is_not_null)
 * - Multi-field sorting
 * - Pagination
 *
 * Note: 'like' and 'ilike' automatically perform substring matching (no manual wildcards needed)
 *
 * Example request body:
 * ```json
 * {
 * "query": {
 * "operator": "and",
 * "conditions": [
 * {
 * "operator": "or",
 * "conditions": [
 * {"comparator": "=", "field": "brand", "value": "lindt"},
 * {"comparator": "ilike", "field": "name", "value": "lindt"}
 * ]
 * },
 * {
 * "comparator": "in",
 * "field": "product_category_id",
 * "value": ["uuid-1", "uuid-2"]
 * },
 * {
 * "comparator": "in",
 * "field": "listing_score_level",
 * "value": ["high", "very_high"]
 * }
 * ]
 * },
 * "order": [
 * {"field": "listing_score", "direction": "desc"}
 * ],
 * "pagination": {
 * "offset": 0,
 * "limit": 10
 * }
 * }
 * ```
 *
 * Available fields:
 * - brand, name, item_id, retailer, source_type, score_status
 * - listing_score, listing_score_at_ingest, raw_listing_score
 * - listing_score_level (use with 'in' comparator and values: very_low, low, moderate, high, very_high)
 * - product_category_id, product_category_name
 * - created_at, updated_at
 */
export const complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPost = <ThrowOnError extends boolean = false>(
  options: Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponses,
    ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Pdp Title Brand
 *
 * Updates title and/or brand for manual PDPs only.
 * Returns 400 if PDP is scraped.
 */
export const updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponses,
    UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/title-brand',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet = <ThrowOnError extends boolean = false>(
  options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponses,
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/images', ...options });

/**
 * Create Pdp Image
 *
 * Creates an Image linked to a Pdp and returns the Image model
 */
export const createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponses,
    CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/images',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Create Pdp Images
 *
 * Creates multiple images linked to a PDP in a single transaction.
 *
 * Idempotency:
 * - If all requested images already exist (by name), returns them with 200
 * - If no images exist, creates all and returns 201
 * - If some exist and some don't, returns 409 Conflict
 */
export const bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponses,
    BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/images/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Pdp Image
 *
 * Delete an image from a PDP. Cannot delete active hero or carousel images.
 */
export const deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponses,
    DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/images/{image_id}', ...options });

/**
 * Get Portfolio Brands
 *
 * Returns distinct brand values for PDPs in the portfolio.
 * Supports pagination and optional search filtering.
 */
export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponses,
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/brands', ...options });

/**
 * Refresh Pdp
 */
export const refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost = <ThrowOnError extends boolean = false>(
  options: Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostResponses,
    RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/refresh', ...options });

/**
 * Create Pdp Snapshot
 */
export const createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponses,
    CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/snapshots', ...options });

/**
 * Update Latest Snapshot Scores
 */
export const updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponses,
    UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutErrors,
    ThrowOnError
  >({
    url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/snapshots/latest/scores',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Original Pdp Snapshot
 *
 * Get the most recent original PDP snapshot for before/after comparison.
 */
export const getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponses,
    GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/original', ...options });

/**
 * Get Scraped Pdp
 */
export const getScrapedPdpV1PdpsRequestIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetScrapedPdpV1PdpsRequestIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetScrapedPdpV1PdpsRequestIdGetResponses,
    GetScrapedPdpV1PdpsRequestIdGetErrors,
    ThrowOnError
  >({ url: '/v1/pdps/{request_id}', ...options });

/**
 * Handle Category Not Found
 */
export const handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPost = <ThrowOnError extends boolean = false>(
  options: Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostResponses,
    HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostErrors,
    ThrowOnError
  >({
    url: '/v1/pdps/{pdp_id}/category-not-found',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Product Categories
 *
 * Retrieves the product categories for an organization
 * The product category names will be formatted in title-case
 *
 * Filters:
 * - breadcrumbs_like: Filter by breadcrumb path containing this string
 * - name_like: Filter by category name containing this string
 * - category_ids: Filter by specific category IDs
 * - scope_to_portfolio: Filter by categories used in PDPs or images for the current portfolio
 * - fallback: If true, try benchmark_lookup.json when no category_ids matches found
 */
export const getProductCategoriesV1ProductCategoriesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetProductCategoriesV1ProductCategoriesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProductCategoriesV1ProductCategoriesGetResponses,
    GetProductCategoriesV1ProductCategoriesGetErrors,
    ThrowOnError
  >({ url: '/v1/product-categories', ...options });

/**
 * Get Product Category
 *
 * Retrieves a single product category by ID or breadcrumbs
 */
export const getProductCategoryV1ProductCategoriesCategoryIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetProductCategoryV1ProductCategoriesCategoryIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductCategoryV1ProductCategoriesCategoryIdGetResponses,
    GetProductCategoryV1ProductCategoriesCategoryIdGetErrors,
    ThrowOnError
  >({ url: '/v1/product-categories/{category_id}', ...options });

/**
 * Get Product Category Audience Name
 *
 * Retrieves the audience name and version for a product category by UUID
 */
export const getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponses,
    GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetErrors,
    ThrowOnError
  >({ url: '/v1/product-categories/{product_category_id}/audience-name', ...options });

/**
 * Get Icp Product Categories
 */
export const getIcpProductCategoriesV1IcpProductCategoriesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetIcpProductCategoriesV1IcpProductCategoriesGetResponses,
    GetIcpProductCategoriesV1IcpProductCategoriesGetErrors,
    ThrowOnError
  >({ url: '/v1/icp-product-categories', ...options });

/**
 * Get Icp Product Categories
 *
 * @deprecated
 */
export const getIcpProductCategoriesV1L1ProductCategoriesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetIcpProductCategoriesV1L1ProductCategoriesGetResponses,
    GetIcpProductCategoriesV1L1ProductCategoriesGetErrors,
    ThrowOnError
  >({ url: '/v1/l1-product-categories', ...options });

/**
 * Get Icp Product Category
 *
 * @deprecated
 */
export const getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponses,
    GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetErrors,
    ThrowOnError
  >({ url: '/v1/l1-product-categories/{icp_product_category_id}', ...options });

/**
 * Get Icp Product Category
 */
export const getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponses,
    GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetErrors,
    ThrowOnError
  >({ url: '/v1/icp-product-categories/{icp_product_category_id}', ...options });

/**
 * Get Recommendations
 */
export const getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponses,
    GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetErrors,
    ThrowOnError
  >({ url: '/v1/portfolios/{portfolio_id}/pdps/{pdp_id}/recommendations', ...options });

/**
 * List Retailer Regions
 *
 * List all supported retailer/region combinations.
 */
export const listRetailerRegionsV1RetailerRegionsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListRetailerRegionsV1RetailerRegionsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListRetailerRegionsV1RetailerRegionsGetResponses,
    ListRetailerRegionsV1RetailerRegionsGetErrors,
    ThrowOnError
  >({ url: '/v1/retailer-regions', ...options });

/**
 * Get Retailer Region
 *
 * Get a specific retailer/region by ID (e.g., 'amazon_uk').
 */
export const getRetailerRegionV1RetailerRegionsRetailerRegionIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponses,
    GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetErrors,
    ThrowOnError
  >({ url: '/v1/retailer-regions/{retailer_region_id}', ...options });

/**
 * Add User To Organization
 */
export const addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponses,
    AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/users/{email_address}', ...options });

/**
 * Delete User
 */
export const deleteUserV1UsersUserIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserV1UsersUserIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteUserV1UsersUserIdDeleteResponses,
    DeleteUserV1UsersUserIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/users/{user_id}', ...options });

/**
 * Get User
 */
export const getUserV1UsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserV1UsersUserIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUserV1UsersUserIdGetResponses, GetUserV1UsersUserIdGetErrors, ThrowOnError>({
    url: '/v1/users/{user_id}',
    ...options,
  });

/**
 * Set Password
 */
export const setPasswordV1UsersUserIdPasswordPost = <ThrowOnError extends boolean = false>(
  options: Options<SetPasswordV1UsersUserIdPasswordPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetPasswordV1UsersUserIdPasswordPostResponses,
    SetPasswordV1UsersUserIdPasswordPostErrors,
    ThrowOnError
  >({
    url: '/v1/users/{user_id}/password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset Password
 */
export const resetPasswordV1UsersPasswordPut = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordV1UsersPasswordPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ResetPasswordV1UsersPasswordPutResponses,
    ResetPasswordV1UsersPasswordPutErrors,
    ThrowOnError
  >({ url: '/v1/users/password', ...options });

/**
 * Login User
 */
export const loginUserV1UsersAuthenticatePost = <ThrowOnError extends boolean = false>(
  options: Options<LoginUserV1UsersAuthenticatePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LoginUserV1UsersAuthenticatePostResponses,
    LoginUserV1UsersAuthenticatePostErrors,
    ThrowOnError
  >({
    url: '/v1/users/authenticate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Exchange Token
 */
export const exchangeTokenV1OrganizationsOrganizationIdAuthorizePost = <ThrowOnError extends boolean = false>(
  options: Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponses,
    ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/authorize', ...options });

/**
 * Remove User From Organization
 */
export const removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponses,
    RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/users/{user_id}', ...options });

/**
 * Get Organizations For User
 */
export const getOrganizationsForUserV1UsersUserIdOrganizationsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganizationsForUserV1UsersUserIdOrganizationsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponses,
    GetOrganizationsForUserV1UsersUserIdOrganizationsGetErrors,
    ThrowOnError
  >({ url: '/v1/users/{user_id}/organizations', ...options });

/**
 * Logout User
 */
export const logoutUserV1UsersUserIdLogoutPost = <ThrowOnError extends boolean = false>(
  options: Options<LogoutUserV1UsersUserIdLogoutPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LogoutUserV1UsersUserIdLogoutPostResponses,
    LogoutUserV1UsersUserIdLogoutPostErrors,
    ThrowOnError
  >({ url: '/v1/users/{user_id}/logout', ...options });

/**
 * Resend Invite
 */
export const resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponses,
    ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/users/{user_id}/resend-invite', ...options });

/**
 * Update Retailer Preference
 */
export const updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponses,
    UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutErrors,
    ThrowOnError
  >({
    url: '/v1/organizations/{organization_id}/users/{user_id}/retailer-preference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Healthcheck
 *
 * A simple endpoint to ping the server and get a response
 */
export const healthcheckHealthcheckGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthcheckHealthcheckGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthcheckHealthcheckGetResponses, HealthcheckHealthcheckGetErrors, ThrowOnError>({
    url: '/healthcheck',
    ...options,
  });

/**
 * Healthcheck
 *
 * A simple endpoint to ping the server and get a response
 */
export const healthcheckGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthcheckGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthcheckGetResponses, HealthcheckGetErrors, ThrowOnError>({
    url: '/',
    ...options,
  });

/**
 * Ready
 *
 * Check the state of the API and the services it depends on
 */
export const readyReadyGet = <ThrowOnError extends boolean = false>(
  options?: Options<ReadyReadyGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ReadyReadyGetResponses, ReadyReadyGetErrors, ThrowOnError>({
    url: '/ready',
    ...options,
  });
